import { useParams } from 'react-router-dom';

import {
  DATASETS_PAGE_TITLE,
  PROJECTS_PAGE_TITLE,
} from '@/constants/pageTitlesAndDescriptionConstants';
import { useOrganizationId, useSession } from '@/hooks/useSwr';
import DatasetIcon from '@/icons/DatasetIcon';
import ProjectIcon from '@/icons/ProjectIcon';
import { appDatasetsPath, appOrganizationPath } from '@/utils/constants';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function ProjectsCrumb(props: Partial<BreadcrumbData>) {
  const { sessionId } = useParams();
  const { data: session } = useSession(sessionId ?? null);
  const hasReferenceDataset = !!session?.reference_dataset_id;
  const organizationId = useOrganizationId();

  if (hasReferenceDataset) {
    return (
      <Breadcrumb
        icon={props.condensed ? <DatasetIcon className="size-4" /> : undefined}
        name={props.condensed ? '' : DATASETS_PAGE_TITLE}
        path={`/${appOrganizationPath}/${organizationId}/${appDatasetsPath}`}
      />
    );
  }

  return (
    <Breadcrumb
      icon={props.condensed ? <ProjectIcon className="size-4" /> : undefined}
      name={props.condensed ? '' : PROJECTS_PAGE_TITLE}
      {...props}
    />
  );
}
